import React from 'react'
import { TableCell, TableRow, Button, Chip } from '@mui/material'
import dayjs from 'dayjs'
type DataRowProps = {
  uid: string
  id: string
  requestedDate: string
  name: string
  email: string
  category: string
  requestedAmount: string
  comment: string
  isPaid: boolean
  onPayClick: (uid: string) => void
}
const DataRow = ({
  uid,
  id,
  requestedDate,
  name,
  email,
  category,
  requestedAmount,
  comment,
  isPaid,
  onPayClick,
}: DataRowProps) => {
  return (
    <TableRow hover tabIndex={-1}>
      <TableCell>{dayjs(requestedDate).format('DD MMM YYYY, hh:mm a')}</TableCell>
      <TableCell>{name}</TableCell>
      <TableCell>{email}</TableCell>
      <TableCell>{category}</TableCell>
      <TableCell>${requestedAmount}</TableCell>
      <TableCell>{comment}</TableCell>
      <TableCell>
        {' '}
        {isPaid ? (
          <Chip color='success' label='Paid' />
        ) : (
          <Chip label='Pending' color='error' />
        )}{' '}
      </TableCell>
      <TableCell align='center'>
        {!isPaid && (
          <Button variant='contained' color='primary' type='button' onClick={() => onPayClick(uid)}>
            Pay
          </Button>
        )}
      </TableCell>
    </TableRow>
  )
}

export default DataRow
